import { useEffect } from 'react';
import { useDispatch } from 'store';
import { triggerNotFound } from 'store/reducers/notFound';

import { TAB_URL_PARAM_MAP } from '../InvoicesTable';

// Monotonic counter — same pattern as TabsGallery / portalAPI middleware. Each dispatch
// gets a fresh triggerKey so the listener re-fires even if the same invalid tab is
// reattempted.
let counter = 0;

// Dispatches /404 when `invoiceTab` is a non-empty value that isn't one of the known
// invoice list tab keys (`main`, `law`, `rev`, `cr`, `acct`, `ksef`). Pass undefined to
// skip validation (e.g. when the page itself owns the redirect to a default tab).
export const useValidInvoiceTab = (invoiceTab: string | undefined): boolean => {
    const dispatch = useDispatch();
    const isValid = invoiceTab === undefined || invoiceTab in TAB_URL_PARAM_MAP;

    useEffect(() => {
        if (invoiceTab !== undefined && !(invoiceTab in TAB_URL_PARAM_MAP)) {
            dispatch(triggerNotFound(`invoiceTab:${invoiceTab}:${++counter}`));
        }
    }, [invoiceTab, dispatch]);

    return isValid;
};
